export function classNames(...classes: any[]) {
  return classes
    .filter(Boolean)
    .map((name) => {
      // Remove multiple spaces in between words and from start & end
      return name.replace(/\s+/g, ' ').trim()
    })
    .join(' ')
}
